export default function singleActionCreators(resourceName, key, actionTypes, api, options) {
	if (resourceName == null) throw new Error('actionCreatorsFor: Expected resourceName');

	let actionCreators = {

		single: function (token, params) {
			return function (dispatch) {
				dispatch(actionCreators.request());

				return api.single(token, params)
					.then(
						response => dispatch(actionCreators.success(response)),
						error => dispatch(actionCreators.failure(error))
					).then(
						response => dispatch(actionCreators.complete()),
						error => dispatch(actionCreators.complete())
					);
			}
		},

		request: function () {
			let name = resourceName + '_SINGLE_REQUEST';

			return {
				type: actionTypes[name]
			}
		},

		success: function (data) {
			let name = resourceName + '_SINGLE_SUCCESS';

			return {
				data: data,
				type: actionTypes[name]
			}
		},

		complete: function () {
			let name = resourceName + '_SINGLE_COMPLETE';

			return {
				data: {},
				type: actionTypes[name]
			}
		},

		failure: function (error, data) {
			let name = resourceName + '_SINGLE_FAILURE';
			assertError(name, error);

			return {
				data: data,
				error: error,
				type: actionTypes[name]
			}
		}
	};

	return actionCreators;
}
